import { ChevronLeft, WifiOff } from "lucide-react";
import { Button } from "../ui/button";
import { SaveStatus, type SaveState } from "./SaveStatus";
import { useOnlineStatus } from "../../hooks/useOnlineStatus";
import logoIcon from "../../favicon-96x96.png";
import { cn } from "../../lib/utils";

type HeaderVariant = "default" | "prominent";

interface HeaderProps {
  title: string;
  onBack?: () => void;
  action?: React.ReactNode;
  showLogo?: boolean;
  saveStatus?: SaveState;
  variant?: HeaderVariant;
}

export function Header({
  title,
  onBack,
  action,
  showLogo,
  saveStatus,
  variant = "default",
}: HeaderProps) {
  const isOnline = useOnlineStatus();
  const isProminent = variant === "prominent";

  return (
    <>
      {!isOnline && (
        <div className="bg-amber-500 text-white text-xs text-center py-1.5 flex items-center justify-center gap-1.5">
          <WifiOff className="h-3 w-3" />
          <span>Sin conexión - Los cambios se guardan localmente</span>
        </div>
      )}
      <header
        className={cn(
          "sticky top-0 z-10 bg-background/80 backdrop-blur-md supports-backdrop-filter:bg-background/60 border-b border-border/40 px-4 pb-3 flex items-center gap-1 safe-area-top transition-colors duration-200"
        )}
      >
        {onBack && (
          <Button
            variant="ghost"
            size="icon"
            onClick={onBack}
            className="rounded-full"
          >
            <ChevronLeft className="h-5 w-5" />
          </Button>
        )}
        {showLogo && <img src={logoIcon} alt="" className="h-10 w-10" />}
        <div className="flex-1 min-w-0">
          <h1
            className={cn(
              "truncate",
              isProminent
                ? "text-2xl font-bold tracking-tight"
                : "text-lg font-semibold"
            )}
          >
            {title}
          </h1>
          {saveStatus && <SaveStatus state={saveStatus} />}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </header>
    </>
  );
}
